import { showToast } from '@slices/apiSlice';
import { baseApi } from '@store/baseQuery';

import { AdditionalExpResponse, DeleteFilePayload, DeleteResponse } from '../types';

export const additionalExperience = baseApi.injectEndpoints({
    endpoints: builder => ({
        getMentorAdditionalExp: builder.query<AdditionalExpResponse, { username: string }>({
            query: args => ({
                url: `/mentor/${args.username}/additional-experience`,
                method: 'GET',
            }),
            providesTags: ['AdditionalExperience'],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch (error) {
                    dispatch(showToast({ variant: 'error', description: error?.error }));
                }
            },
        }),
        getMenteeAdditionalExp: builder.query<AdditionalExpResponse, { username: string }>({
            query: args => ({
                url: `/mentee/${args.username}/additional-experience`,
                method: 'GET',
            }),
            providesTags: ['AdditionalExperience'],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch (error) {
                    dispatch(showToast({ variant: 'error', description: error?.error }));
                }
            },
        }),
        updateMentorAdditionalExp: builder.mutation<AdditionalExpResponse, FormData>({
            query: body => ({
                url: `/mentor/additional-experience`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['AdditionalExperience'],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                    dispatch(
                        showToast({
                            variant: 'success',
                            description: 'Additonal Experience updated successfully',
                        })
                    );
                } catch (error) {
                    dispatch(showToast({ variant: 'error', description: error?.error }));
                }
            },
        }),
        updateMenteeAdditionalExp: builder.mutation<AdditionalExpResponse, FormData>({
            query: body => ({
                url: `/mentee/additional-experience`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['AdditionalExperience'],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                    dispatch(
                        showToast({
                            variant: 'success',
                            description: 'Additonal Experience updated successfully',
                        })
                    );
                } catch (error) {
                    dispatch(showToast({ variant: 'error', description: error?.error }));
                }
            },
        }),

        deleteMentorCertificate: builder.mutation<DeleteResponse, DeleteFilePayload>({
            query: body => ({
                url: `/mentor/additional-experience/certificates`,
                method: 'DELETE',
                body,
            }),
            invalidatesTags: ['AdditionalExperience'],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch (error) {
                    dispatch(showToast({ variant: 'error', description: error?.error }));
                }
            },
        }),
        deleteMenteeCertificate: builder.mutation<DeleteResponse, DeleteFilePayload>({
            query: body => ({
                url: `/mentee/additional-experience/certificates`,
                method: 'DELETE',
                body,
            }),
            invalidatesTags: ['AdditionalExperience'],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch (error) {
                    dispatch(showToast({ variant: 'error', description: error?.error }));
                }
            },
        }),
    }),
    overrideExisting: true,
});

export const {
    useLazyGetMentorAdditionalExpQuery,
    useLazyGetMenteeAdditionalExpQuery,
    useUpdateMentorAdditionalExpMutation,
    useUpdateMenteeAdditionalExpMutation,
    useDeleteMentorCertificateMutation,
    useDeleteMenteeCertificateMutation,
} = additionalExperience;
